import sortedByDate from "./sorted-by-date";

const jmoins31 = new Date().getTime() - 1000 * 3600 * 24 * 31;
const initialState = sortedByDate.reduce((nouveau, modele, id) => {
    const { row, col } = modele;
    if (modele.date < jmoins31) {
        return nouveau;
    }
    return [
        {
            dimension: `${row}x${col}`,
            id: id,
        },
        ...nouveau,
    ];
}, []);

export default (state = initialState, action) => {
    return state;
};
